import React from "react";
import Navigation from "./Navigation";

function NotFound(props) {
  return (
    <div>
      <Navigation />
      <h1>Sorry Not Found</h1>
    </div>
  );
}

export default NotFound;
